<div class="container-box">
  <div class="timeline-page">
    <!-- Header -->
    <div class="page-header">
      <div class="header-left">
        <h2 class="page-title">
          <i class="fas fa-calendar-alt title-icon"></i>
          Timeline Noleggi
        </h2>
      </div>
      <div class="header-actions">
        <button class="btn-icon" (click)="refreshTimeline()" title="Aggiorna">
          <i class="fas fa-sync-alt"></i>
        </button>
      </div>
    </div>

    <!-- Filters Panel -->
    <div class="filters-panel">
      <div class="filters-header">
        <span class="filters-title">
          <i class="fas fa-filter"></i>
          Filtri
        </span>
      </div>

      <div class="filters-grid">
        <!-- Gruppo: Periodo -->
        <div class="filter-group">
          <span class="filter-group-label">Periodo</span>
          <div class="filter-group-fields">
            <mat-form-field appearance="outline">
              <mat-label>Da</mat-label>
              <input matInput [matDatepicker]="startPicker" [formControl]="filterStartDate" />
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>A</mat-label>
              <input matInput [matDatepicker]="endPicker" [formControl]="filterEndDate" />
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <!-- Gruppo: Marca -->
        <div class="filter-group">
          <span class="filter-group-label">Marca</span>
          <div class="filter-group-fields">
            <mat-form-field appearance="outline">
              <mat-label>Marca</mat-label>
              <mat-select [formControl]="filterMarcaId">
                <mat-option *ngFor="let brand of brands" [value]="brand.id">
                  {{ brand.codiceMarca }} - {{ brand.descrizioneMarca }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="timeline-actions">
      <button class="btn-action" (click)="openNewReservationDialog()">
        <i class="fas fa-plus"></i>
        Nuova Prenotazione
      </button>
    </div>

    <!-- Timeline Toolbar -->
    <div class="timeline-toolbar">
      <!-- Legenda -->
      <div class="legend">
        <div class="legend-item">
          <span class="legend-dot legend-dot--noleggio"></span>
          <span class="legend-label">Noleggio</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot legend-dot--prenotazione"></span>
          <span class="legend-label">Prenotazione</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot legend-dot--prenotazione-libera"></span>
          <span class="legend-label">Prenotazione libera</span>
        </div>
      </div>

      <!-- Navigazione rapida -->
      <div class="nav-buttons">
        <button class="nav-btn" (click)="goToToday()">
          <i class="fas fa-crosshairs"></i>
          Oggi
        </button>
        <button class="nav-btn" (click)="goToWeek()">
          <i class="fas fa-calendar-week"></i>
          Settimana
        </button>
        <button class="nav-btn" (click)="goToMonth()">
          <i class="fas fa-calendar"></i>
          Mese
        </button>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <span class="loading-text">Caricamento timeline...</span>
    </div>

    <!-- Timeline container -->
    <div class="timeline-card" [hidden]="isLoading">
      <div #timelineContainer class="timeline-wrapper"></div>
    </div>
  </div>
</div>
